// extracted by mini-css-extract-plugin
module.exports = {"blocked":"c_b","loader":"c_c","blog":"c_m","blog__categoryItem__wrap":"c_n"};